/**
 * Do not edit directly
 * Generated on Thu, 12 Jun 2025 21:02:51 GMT
 */

export const TYPOGRAPHY_FAMILY_NUNITO = "'Nunito', sans-serif";
export const TYPOGRAPHY_FAMILY_ROBOTO = "'Roboto', sans-serif";
export const TYPOGRAPHY_FONT_WEIGHT_BOLD = "700";
export const TYPOGRAPHY_FONT_WEIGHT_REGULAR = "400";
export const TYPOGRAPHY_SIZE_TITLE_XL = "1.5rem";
export const TYPOGRAPHY_SIZE_TITLE_LG = "1.25rem";
export const TYPOGRAPHY_SIZE_TITLE_MD = "1.125rem";
export const TYPOGRAPHY_SIZE_TITLE_SM = "1rem";
export const TYPOGRAPHY_SIZE_TITLE_XS = "0.875rem";
export const TYPOGRAPHY_SIZE_PARAGRAPH_LG = "1rem";
export const TYPOGRAPHY_SIZE_PARAGRAPH_MD = "0.875rem";
export const TYPOGRAPHY_SIZE_PARAGRAPH_SM = "0.75rem";
export const TYPOGRAPHY_SIZE_PARAGRAPH_XS = "0.625rem";
export const TYPOGRAPHY_SIZE_H1 = "1.5rem";
export const TYPOGRAPHY_SIZE_H2 = "1.25rem";
export const TYPOGRAPHY_SIZE_H3 = "1.125rem";
export const TYPOGRAPHY_SIZE_H4 = "1rem";
export const TYPOGRAPHY_SIZE_H5 = "0.75rem";
export const TYPOGRAPHY_SIZE_H6 = "0.625rem";
export const TYPOGRAPHY_SIZE_P = "0.875rem";
export const TYPOGRAPHY_LINE_HEIGHT_TITLE_XL = "1.75rem";
export const TYPOGRAPHY_LINE_HEIGHT_TITLE_LG = "1.5rem";
export const TYPOGRAPHY_LINE_HEIGHT_TITLE_MD = "1.375rem";
export const TYPOGRAPHY_LINE_HEIGHT_TITLE_SM = "1.25rem";
export const TYPOGRAPHY_LINE_HEIGHT_TITLE_XS = "1.125rem";
export const TYPOGRAPHY_LINE_HEIGHT_PARAGRAPH_LG = "1.375rem";
export const TYPOGRAPHY_LINE_HEIGHT_PARAGRAPH_MD = "1.25rem";
export const TYPOGRAPHY_LINE_HEIGHT_PARAGRAPH_SM = "1rem";
export const TYPOGRAPHY_LINE_HEIGHT_PARAGRAPH_XS = "0.875rem";
